import _ from "lodash";
import { toast } from 'react-toastify'

import API from "../../api";
import { queryClient } from "../../react-query"
import { useChecklist } from "../../../store/service-activation/useChecklist";
import { formatResponses } from '../../formatResponses/checklist';
import {formatTemplateData} from "../../formatTemplateData/checklist";

export class ChecklistModel {
  checklistAction = useChecklist.getState().actions

  constructor(props) {
    this.merchantModel = props.models.merchant
  }

  async getConfig() {
    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['checklist', 'config'],
        queryFn: async () => await API.get("checklist/config"),
      })

      this.checklistAction.setConfig(formatResponses.formatConfig(result.data))
      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar as configurações do Checklist', { theme: 'colored' })
      return {}
    }
  }

  async updateConfig(data) {
    const currentConfig = useChecklist.getState().data.config
    try {
      this.checklistAction.setConfig({...currentConfig, ...data})

      const result = await API.put("checklist/config", formatTemplateData.formatConfig({...currentConfig, ...data}))

      queryClient.setQueryData( ['checklist', 'config'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      this.checklistAction.setConfig(formatResponses.formatConfig(result.data))
      this.merchantModel.findMerchant().then()

      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível atualizar as configurações do Checklist', { theme: 'colored' })
      this.checklistAction.setConfig(currentConfig)
      return {}
    }
  }
}
